
import XLSX from "xlsx";
import $api from '@/apiProvider'
import UploadList from '@/components/common/UploadList'
import Account from '@/components/modal/Account'
import BankAccount from '@/components/modal/BankAccount'
import { getExcelTime, paymentFooter, showLoading, hideLoading, showFailMsgList, isEmpty, isNotEmpty } from '@/utils/util'
import TableHeader from '@/components/common/TableHeader'
import SalesMan from '@/components/common/SalesMan'
import PlatformCorp from '@/components/common/PlatformCorp'
import CustomerSelect from '@/components/common/CustomerSelect'
import getAuthOrization from "@/mixin/getAuthOrization";
import AboutPaymentOrder from "@/components/order/AboutPaymentOrder";

const assign = (o) => Object.assign({}, o)

export default {
    mixins: [getAuthOrization],
    name: 'CreatePayment',
    components: {
        CustomerSelect,
        PlatformCorp,
        SalesMan,
        TableHeader,
        ChooseOrder: AboutPaymentOrder,
        UploadList,
        BankAccount,
        ChooseAccount: Account
    },
    props: {
        cate: {
            type: String,
            default: ''
        },
        isShow: {
            type: Boolean,
            default: false
        },
        isImport: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            createAction: '',
            canInsert: true,
            isShowChooseOrder: false,
            //选择银行账户
            isShowBankAccountModal: false,
            bankAccountModalTitle: '选择银行账户',

            isShowChooseAccount: false,// 选择客户

            amountListName: '', //关联订单的字段名
            dataTmp: {
                index: '',
                "ordersNumb": null,
                "addTime": '',
                "fileUuidList": [],
                "fileList": [],
                "note": null,
                "operUser": null,
                "ordersBuyerAmountList": [],
                "ordersSellerAmountList": [],
                "ordersSellerLv2sAmountList": [],
                "payAccount": null,
                "payAmount": "",
                "payBank": null,
                "payBankCode": null,
                "paymentsName": null,
                "recAccount": null,
                "recBank": null,
                "recName": null,
                "unusedAmount": 0,
                "usedAmount": 0,
                compName: '',
                isOrderCompName: false,
                salesMan: '',
                isOrdersalesMan: false,
                clientName: '',
                isOrderClientName: false

            },
            tableData: [],
            editRules: {
                ordersNumb: [
                    { validator: this.requireValid }
                ],
                salesMan: [
                    { validator: this.requireValid }
                ],
                compName: [
                    { validator: this.requireValid }
                ],
                clientName: [
                    { validator: this.requireValid }
                ],
                payAmount: [
                    { validator: this.requireValid }
                ],
                addTime: [
                    { validator: this.requireValid }
                ],
                note: [
                    { validator: this.requireValid }
                ],
                paymentsName: [
                    { validator: this.requireValid }
                ],
                recName: [
                    { validator: this.requireValid }
                ],
            },
            platformCompMap: {}
        };
    },
    watch: {
        isShow: {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                if (val == false && oldVal == true) {
                    if (isNotEmpty(this.$refs.xTable)) {
                        this.$refs.xTable.clearValidate()
                        this.updateFooterEvent()
                    }
                    this.tableData = []
                    this.canInsert = true
                }
                if (val == true) {
                    this.insertEvent()
                }
            }
        },
        cate: {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                switch (val) {
                    case 'Collection':
                        this.amountListName = 'ordersBuyerAmountList'
                        this.createAction = 'createPaymentsBuyer'
                        break
                    case 'Payment':
                        this.amountListName = 'ordersSellerAmountList'
                        this.createAction = 'createPaymentsSeller'
                        break
                    case 'SellerPayment':
                        this.amountListName = 'ordersSellerLv2sAmountList'
                        this.createAction = 'createPaymentsSellerLv2'
                        break
                }
            }
        },
    },
    methods: {
        initByChainId(chainId) {
            let orderInfo = this.getBuyerOrderInfoByChainId(chainId);
            orderInfo.then(res => {
                if (null != res) {
                    this.initByOrderInfo(res);
                }
            })
        },
        //查托运人订单
        async getBuyerOrderInfoByChainId(chainId) {
            let orderInfo = null;
            let res = await $api.order.post("queryOrdersBuyerList", {
                chainId: chainId,
                page: 1,
            });
            if (res.status == 1 && res.data.rows.length > 0) {
                let orderRes = await $api.order.post("queryOrdersBuyerDetail", {
                    id: res.data.rows[0].id,
                });
                if (orderRes.status == 1) {
                    orderInfo = orderRes.data;
                }
            }
            return orderInfo;
        },
        initByOrderInfo(orderInfo) {
            console.log('创建收付款 通过 订单号初始化 - 开始', orderInfo, this.cate)
            this.insertEvent()
            this.currentRow = this.$refs.xTable.getTableData().tableData[0]
            //托运人 承运人 取订单号
            orderInfo.ordersNumb = this.cate === 'Collection' ? orderInfo.buyerOrdersNum : orderInfo.sellerOrdersNum
            orderInfo.ordersId = orderInfo.id
            orderInfo.id = null
            this.chooseOrderEvent([orderInfo], 0)
            if (isNotEmpty(orderInfo.platformCompanyId)) {
                this.currentRow.compName = orderInfo.platformCompany
                this.currentRow.platformCompanyId = orderInfo.platformCompanyId
            }
            if (isNotEmpty(orderInfo.salesMan)) {
                this.currentRow.salesMan = orderInfo.salesManName
                this.currentRow.salesManId = orderInfo.salesMan
            }
            this.$refs.xTable.reloadData([this.currentRow])
            this.canInsert = false
            console.log('创建收付款 通过 订单号初始化 - 结束', this.cate, this.currentRow)
        },
        initByCate(cate) {
            console.log(this.cate, cate)
        },
        async requireValid(e) {
            if (e.columnIndex == 3 && isEmpty(e.row.compName)) {
                return Promise.reject(new Error('请先选择所属公司'))
            }
            if (e.columnIndex == 6 && !(e.row.payAmount > 0)) {
                return Promise.reject(new Error('请先填写付款金额'))
            }
            if (isNotEmpty(e.row.compName) && e.row.aboutAmount > 0 && e.columnIndex == 2 && this.isImport && isEmpty(e.row.ordersNumb)) {
                return Promise.reject(new Error('导入必须填写订单号'))
            }
            if (isEmpty(e.cellValue)) {
                if (e.columnIndex == 2 && !this.isImport || e.columnIndex < 6 && !(e.row.payAmount > 0) || isEmpty(e.row.compName)) {
                    console.log('优先验证金额 或者 公司')
                } else {
                    return Promise.reject(new Error(e.column.title + '必填'))
                }
            }
        },
        async impotEvent() {
            await this.initPlatCompMap()
            this.$refs.xTable.readFile({
                types: ['xls', 'xlsx']
            }).then(evnt => {
                showLoading()
                const tableData = [];
                const files = evnt.target.files;
                const fileReader = new FileReader();
                fileReader.onload = (ev) => {
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, { type: 'binary' });
                    const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
                    // 解析数据
                    let xlsxData = csvData.split('\n');
                    //删除xlsx列名
                    xlsxData.splice(0, 1);
                    xlsxData.forEach((vRow) => {
                        if (vRow) {
                            const vCols = vRow.split(',');
                            let item = {
                                index: vCols[0],//需要
                                ordersNumb: vCols[1],//承运人订单号
                                compName: vCols[2],
                                isOrderCompName: false,
                                salesMan: vCols[3],
                                isOrdersalesMan: false,
                                clientName: vCols[4],
                                isOrderClientName: false,
                                addTime: getExcelTime(vCols[5]),//收款日期
                                note: vCols[6],//摘要
                                recName: vCols[7],//收款企业（人）名称
                                recBank: vCols[8],//开户行
                                recAccount: vCols[9],//银行卡号
                                paymentsName: vCols[10],//付款企业（人）名称
                                payBank: vCols[11],//开户行
                                payAccount: vCols[12],//银行卡号
                                payAmount: vCols[13],//付款金额
                                payBankCode: vCols[14],//支付凭证流水号
                                "fileUuidList": [],
                                "fileList": [],
                                "operUser": null,
                                "ordersBuyerAmountList": [],
                                "ordersSellerAmountList": [],
                                "ordersSellerLv2sAmountList": [],
                                "unusedAmount": 0,
                                "usedAmount": 0
                            };
                            item[this.amountListName] = [{
                                ordersNum: item.ordersNumb,
                                ordersNumb: item.ordersNumb,
                                aboutAmount: item.payAmount
                            }]
                            item.platformCompanyId = this.platformCompMap[item.compName]
                            tableData.push(item);
                        }
                    })
                    this.tableData = tableData;
                    this.updateFooterEvent()
                    setTimeout(() => {
                        hideLoading();
                    }, 1000);
                }
                fileReader.readAsBinaryString(files[0]);
            })
        },
        insertEvent() {
            if (isEmpty(this.$refs.xTable)) return
            let tableData = this.$refs.xTable.getTableData().tableData
            this.$refs.xTable.clearValidate()
            let record = assign(this.dataTmp)
            if (!this.canInsert) {
                //不能新增的情况下 都是复制第一条的
                if (tableData.length > 0) {
                    let amountList = [assign(tableData[0][this.amountListName][0])]
                    record = Object.assign(record, {
                        ordersNumb: tableData[0].ordersNumb,//承运人订单号
                        ordersId: tableData[0].ordersId,
                        salesMan: tableData[0].salesMan,
                        salesManId: tableData[0].salesManId,
                        compName: tableData[0].compName,
                        platformCompanyId: tableData[0].platformCompanyId,
                        [this.amountListName]: amountList
                    })
                }
            }
            record.index = tableData.length + 1
            record.fileList = []
            record.fileUuidList = []
            this.$refs.xTable.insertAt(record, -1)
            this.$refs.xTable.updateStatus()
            this.updateFooterEvent()
        },
        async removeEvent() {
            let checkboxRecords = this.$refs.xTable.getCheckboxRecords()
            if (isEmpty(checkboxRecords)) {
                this.$XModal.message({ message: '没有选择' })
                return
            }
            if (!this.canInsert) {
                //不能全部删除
                if (checkboxRecords.length == this.$refs.xTable.getTableData().tableData.length) {
                    this.$XModal.message({ message: '不能全部删除,至少保留一条' })
                    return
                }
            } 
            let confirmRes = await this.$XModal.confirm(
                "删除后不可恢复",
                "是否删除？"
            );
            if (confirmRes == 'confirm') {
                this.$refs.xTable.removeCheckboxRow()
                this.$refs.xTable.updateStatus()
            }
        },
        copyEvent() {
            let checkboxRecords = this.$refs.xTable.getCheckboxRecords()
            if (isEmpty(checkboxRecords)) {
                this.$XModal.message({ message: '没有选择' })
                return
            }
            let newRecords = []
            checkboxRecords.forEach(item => {
                let newItem = assign(item)
                let newAmountList = []
                newItem[this.amountListName].forEach(i => {
                    newAmountList.push(assign(i))
                })
                newItem[this.amountListName] = newAmountList
                console.log(newItem)
                newRecords.push(assign(newItem))
            })
            this.$refs.xTable.insertAt(newRecords, -1)
            this.$refs.xTable.updateStatus()
        },
        cellClickEvent(e) {
            this.$refs.xTable.clearValidate()
        },
        async selectCompName(row, id, name) {
            if (isNotEmpty(row.compName) && row.compName != name && isNotEmpty(row[this.amountListName])) {
                let confirmRes = await this.$XModal.confirm(
                    "更换所属平台公司将清空关联订单",
                    "是否更换"
                );
                if (confirmRes === "confirm") {
                    row[this.amountListName] = []
                    row.ordersNumb = ''
                } else {
                    return
                }
            }
            row.platformCompanyId = id
            row.compName = name
        },
        async openOrderModal(row) {
            if (isNotEmpty(row.payAmount) && row.payAmount > 0) {
                if (this.canInsert) {
                    if (isEmpty(row.platformCompanyId)) {
                        this.$XModal.message({ message: "所属平台公司名称错误" })
                        return
                    }
                    this.currentRow = row
                    this.isShowChooseOrder = true
                    this.$refs.refPaymentAboutOrder.init(this.cate, 0, row.payAmount, row[this.amountListName], row.platformCompanyId)
                }
            } else {
                await this.$refs.xTable.clearValidate()
                await this.$refs.xTable.validate(row, (err) => { })
            }
        },
        openChooseAccount(row, field) {
            this.isShowChooseAccount = true
            this.currentRow = row
            this.currentChooseColumn = field
            this.$refs.chooseAccount.init()
        },
        chooseAccountEvent(account, type) {
            console.log('chooseAccountEvent', account)
            // this.currentRow[this.currentChooseColumn] = type === 1 ? account.compName : account.realName;
            this.currentRow[this.currentChooseColumn] = account.userName;
            this.isShowChooseAccount = false
            this.$refs.xTable.clearValidate(this.currentChooseColumn)
        },
        chooseOrderEvent(amountList, usedAmount) {
            console.log('chooseOrderEvent', amountList, usedAmount)
            this.isShowChooseOrder = false
            this.$refs.xTable.clearValidate('ordersNumb')

            //关联订单数据 
            this.currentRow.usedAmount = usedAmount
            this.currentRow[this.amountListName] = amountList
            if (amountList.length > 0) {
                this.currentRow.ordersNumb = amountList[0].ordersNumb
            } else {
                this.currentRow.ordersNumb = ''
            }
        },
        openBankAccountModal(row, field, accountCate) {
            this.currentRow = row
            this.currentChooseColumn = field
            this.isShowBankAccountModal = true
            this.bankAccountModalTitle = accountCate == 'platform' ? '选择平台银行账户' : '选择用户银行账户'
            this.$refs.bankAccountModal.init(accountCate)
        },
        chooseBankAccount(bankAccount) {
            if (this.currentChooseColumn == 'paymentsName') {
                this.currentRow.payBank = bankAccount.bankName
                this.currentRow.paymentsName = bankAccount.accountName
                this.currentRow.payAccount = bankAccount.accountNum
            } else {
                this.currentRow.recBank = bankAccount.bankName
                this.currentRow.recName = bankAccount.accountName
                this.currentRow.recAccount = bankAccount.accountNum
            }
            this.isShowBankAccountModal = false
            this.$refs.xTable.clearValidate(this.currentChooseColumn)
        },
        closeBankAccount() {
            console.log('closeBankAccount')
            this.isShowBankAccountModal = false
        },
        inputPayAmountEvent(row) {
            if (isNotEmpty(row.payAmount) && row.ordersNumb == ' ') {
                row.ordersNumb = null
            }
            if (isNaN(parseFloat(row.payAmount))) {
                row.payAmount = null
            }
            //从订单进入创建,  没有关联金额, 输入付款金额保存到关联金额
            if (!this.canInsert && isNotEmpty(row.payAmount)) {
                row[this.amountListName][0].aboutAmount = row.payAmount
            }
            this.$refs.xTable.clearValidate('payAmount')
            this.updateFooterEvent()
        },
        async validEvent() {
            const errMap = await this.$refs.xTable
                .validate()
                .catch((errMap) => errMap);
            return errMap ? false : true
        },
        uploadFile() {
            alert('上传附件')
        },
        async submitEvent() {
            this.$refs.xTable.updateStatus()
            let sts = await this.validEvent()
            if (!sts) {
                this.$XModal.message({ status: "error", message: "校验不通过！" });
                return
            }
            let table = this.$refs.xTable.getTableData()

            if (table.tableData.length == 0) {
                this.$XModal.message({ message: "请先添收付款" });
                return
            }

            let rows = []

            table.tableData.forEach(item => {
                if (isEmpty(item[this.amountListName]) && isNotEmpty(item.ordersNumb)) {
                    //导入复制的少了 关联的列表
                    item[this.amountListName] = [{
                        ordersNum: item.ordersNumb,
                        ordersNumb: item.ordersNumb,
                        aboutAmount: item.payAmount
                    }]
                }
                let row = assign(item)
                row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime))
                row.usedAmount = 0
                if (row[this.amountListName].length == 1 && (row[this.amountListName][0].ordersNumb == '' || row[this.amountListName][0].ordersNumb == null)) {
                    row[this.amountListName] = []
                } else {
                    row[this.amountListName].forEach(aboutOrder => {
                        row.usedAmount = Math.round(row.usedAmount* 100) / 100 + Math.round(aboutOrder.aboutAmount* 100) / 100
                    })
                }
                row.unusedAmount = Math.round(row.payAmount* 100) / 100 - Math.round(row.usedAmount* 100) / 100
                rows.push(row)
            });

            showLoading()
            let res = await $api.payments.request(this.createAction, rows)
            hideLoading()

            if (res.status == 1) {
                this.$XModal.message({ status: "success", message: '提交成功' })
                this.tableData = []
                this.$emit('close')
            } else if (res.status == 0) {
                //检查部分失败的情况
                let errorData = []
                res.data.forEach(failItem => {
                    errorData.push(assign(this.tableData[failItem.failArrayIndex]))
                })
                this.tableData = errorData
                showFailMsgList(res.data)
                // this.$XModal.message({ status: "success", message: res.data[0].failMsg })
            } else {
                if (!res.message) {
                    res.message = '接口异常'
                }
                this.$XModal.message(res.message)
            }
            this.$emit('init')
        },
        footerCellClassName({ $rowIndex, column, columnIndex }) {
            return 'footer-cell'
        },
        footerMethod({ columns, data }) {
            return paymentFooter({ columns, data, rowName: '合计' })
        },
        updateFooterEvent() {
            this.$refs.xTable.updateFooter()
        },
        async initPlatCompMap() {
            if (isEmpty(this.platformCompMap)) {
                let res = await $api.department.get("listCompany")
                let map = {}
                res.data.rows.forEach(item => {
                    map[item.name] = item.id
                })
                this.platformCompMap = map
            }
        }
    },
};